// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CompareInfo{color:#000;position:relative}@media(min-width:768px){.CompareInfo{margin-right:1rem}}@media(min-width:1024px){.CompareInfo{margin-right:1.5rem}}.CompareInfo>svg{height:1rem;width:1rem}@media(min-width:768px){.CompareInfo>svg{height:1.125rem;width:1.125rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
